import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { TextField } from 'redux-form-material-ui';

import {
  Field, change, Form, formValueSelector,
} from 'redux-form';

import { Typography, Button, Step, Stepper, StepContent, StepLabel } from '@material-ui/core';

import { FORM_NAME, FORM_DEFINITION } from './index';
import { save, saveIncompleteWorkflow, getIncompleteWorkflows } from '../../../redux/actions/workflowActions';
import globalStyles from '../../../styles';
import { getComponents } from '../../../redux/actions/tracker/componentsActions';

import WorkflowPhases from './WorkflowPhases';
import WorkflowConfirmDialog from './WorkflowConfirmDialog';
import { setWorkflowData } from '../../../redux/workflow';
import { getAuthUser } from '../../../redux/actions/authActions';


const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = state => ({
  workflowData: state.workflowReducer.workflowData,
  workflowId: state.workflowReducer.workflowId,
  companyList: state.workflowReducer.companyList,
  isFinished: state.workflowReducer.isFinished,
  saveData: state.workflowReducer.saveData,
  confirmDialog: state.workflowReducer.confirmDialog,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  save,
  saveIncompleteWorkflow,
  getComponents,
  setWorkflowData,
  getIncompleteWorkflows,
}, dispatch);


const steps = ['Definir Fluxo de Atividade', 'Criar Fases'];
const user = getAuthUser();

export class WorkflowReduxForm extends Component {

  static propTypes = {
    onActivateSave: PropTypes.func,
  };

  static defaultProps = {
    onActivateSave: () => console.log('onActivateSave!'),
  };

  constructor(props) {

    super(props);
    this.state = {
      activeStep: 0,
      inputValue: '',
      phases: [],
      lstComponents: [],
      stepsConclued: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.setFormValues = this.setFormValues.bind(this);
    this.onConfirmPhase = this.onConfirmPhase.bind(this);

    this.onRemovePhase = this.onRemovePhase.bind(this);
    this.onAddDynamicField = this.onAddDynamicField.bind(this);
    this.onRemoveDynamicField = this.onRemoveDynamicField.bind(this);
    this.handlePhaseOpenClose = this.handlePhaseOpenClose.bind(this);
    this.closeConfirmDialog = this.closeConfirmDialog.bind(this);
    this.forceRender = this.forceRender.bind(this);

  }

  componentDidMount() {

    const { reset, workflowData, getComponents } = this.props;

    reset();


    getComponents().then(lstComponents => this.setState({ lstComponents }));

    if (workflowData) this.setFormValues(workflowData);

  }


  setFormValues(values) {

    const { dispatch } = this.props;


    Object.keys(values).forEach((key) => {

      let value = '';
      switch (key) {

        case 'dateCreated':
          value = new Date(values[key]);
          break;


        default:
          value = values[key];

      }

      dispatch(change(FORM_NAME, key, value));

    });

  }


   getStepContent = (step) => {

     switch (step) {
       case 0:
         return this.renderForm();
       case 1:
         return this.renderPhases();
       default:
         return 'Unknown step';
     }

   }

  onChange = (e) => {

    this.setState({ inputValue: e.target.value });

  };

  handleNextStep = () => {


    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));


    if ((this.state.activeStep + 1) === steps.length) {

      this.props.onActivateSave();
      this.setState({
        stepsConclued: true,
      });

    }

  };

  handleBackStep = () => {

    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));

  };


  onConfirmPhase(event) {

    const { inputValue, phases } = this.state;

    event.preventDefault();

    if (inputValue) {

      const step = {
        name: inputValue,
        position: phases.length,
        fieldsList: [],
        open: false,
      };
      const nextState = [...phases, step];

      this.setState({
        phases: nextState,
        inputValue: '',
      });

    }

  }


  onRemovePhase(item, i) {

    const { phases } = this.state;

    phases.splice(i ,1)
    phases.map((obj, index) => obj.position = index);
    this.forceRender();
    
  }

  onAddDynamicField(item, i) {

    const { phases } = this.state;

    item.fieldsList.push({ name: '', componentId: -1 });
    this.forceRender();


  }

  onRemoveDynamicField(item, i, items) {
    items.splice(i ,1)
    this.forceRender();
  }


 handlePhaseOpenClose = (item) => {

   item.open = !item.open;
   this.forceRender();

 };

 closeConfirmDialog(condition) {

   this.props.setWorkflowData({ confirmDialog: false });

   if (condition)
     this.saveIncompleteWorkflow();

 }

 saveIncompleteWorkflow(confirm, data) {

   const { saveIncompleteWorkflow, saveData } = this.props;

   return saveIncompleteWorkflow(data || saveData ).then(() => {

     if (confirm)
       this.recoverLastIncomplete();
     else
       this.props.onSaveComplete();

   }, (errors) => {

     throw errors;

   });

 }

 recoverLastIncomplete() {

   const { getIncompleteWorkflows, save } = this.props;
   const { phases } = this.state;

   setTimeout(() => {

     getIncompleteWorkflows(user.context.idHolding).then((response) => {

       const workflowId = response[response.length - 1].workFlowId;
       setWorkflowData({ workflowIncompleteList: response, workflowId });
       return save(workflowId, phases).then(() => this.props.onSaveComplete(), (errors) => {

         throw errors;

       });


     });

   }, 100);

 }

 onSubmit(data) {

   const { save, dispatch, isFinished, workflowId } = this.props;

   const { phases } = this.state;


   if (!isFinished) {

     this.props.setWorkflowData({ confirmDialog: true, saveData: data });
     return null;

   }

   if (workflowId)

     return save(workflowId, phases).then(() => this.props.onSaveComplete(), (errors) => {

       throw errors;

     });

   this.saveIncompleteWorkflow(true, data);

 }

 forceRender() {

   this.forceUpdate();

 }

 render() {

   const {
     handleSubmit, isFinished, confirmDialog,

   } = this.props;


   const { activeStep } = this.state;


   return (

     <div>
       <Form form={FORM_NAME} onSubmit={handleSubmit(this.onSubmit)}>

         <Stepper activeStep={activeStep} orientation="vertical">
           {steps.map((label, index) => (
             <Step key={label}>
               <StepLabel>{label}</StepLabel>
               <StepContent>
                 <Typography>{this.getStepContent(index)}</Typography>
                 <div >
                   <Button
                     disabled={activeStep === 0}
                     onClick={this.handleBackStep}
                   >
                     { I18n.t('button.previous') }
                   </Button>
                   <Button
                     variant="contained"
                     color="primary"
                     onClick={this.handleNextStep}
                   >
                     {activeStep === steps.length - 1 ? `${I18n.t('button.finish')} ` : `${I18n.t('button.next')}` }
                   </Button>
                 </div>
               </StepContent>
             </Step>
           ))}
         </Stepper>
       </Form>

       <WorkflowConfirmDialog
         open={confirmDialog && !isFinished}
         onClose={this.closeConfirmDialog}
       />

     </div>
   );

 }

 renderForm() {

   return (<div>
     <Field
       name="name"
       component={TextField}
       label={I18n.t('fields.name')}
       fullWidth
       disabled={this.props.submitting}
       onKeyPress={(event) => {

         if (event.key === 'Enter') this.handleNextStep();

       }}
     />

   </div>
   );

 }

 renderPhases() {

   const { inputValue, phases, lstComponents } = this.state;

   return (
     <div>
       <TextField
         id="stepName"
         label="Nome da fase"
         value={inputValue}
         style={globalStyles.textField}
         onChange={this.onChange}
         margin="normal"
         autoComplete={false}
         onKeyPress={(event) => {

           if (event.key === 'Enter') this.onConfirmPhase(event);

         }}
       />

       <Button onClick={this.onConfirmPhase} type="button" color="primary" variant="contained">
         {I18n.t('button.create')}
       </Button>

       {phases.length > 0 &&
       <WorkflowPhases phases={phases} onAddPhase={this.onAddPhase} onRemovePhase={this.onRemovePhase} onAddDynamicField={this.onAddDynamicField} onRemoveDynamicField={this.onRemoveDynamicField} handleOpenClose={this.handlePhaseOpenClose} lstComponents={lstComponents} forceRender={this.forceRender} />
       }
     </div>
   );

 }

}


export default FORM_DEFINITION(
  connect(mapStateToProps, mapDispatchToProps)(WorkflowReduxForm),
);



// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowReduxForm.js